export default __webpack_public_path__ + "static/media/11.f5691ef2.jpg";